import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDsaGTOEOMCiXeAoE-E2Fbmg7f9yVGLqGU",
  authDomain: "a5omic.firebaseapp.com",
  projectId: "a5omic",
  storageBucket: "a5omic.firebasestorage.app",
  messagingSenderId: "1035462327573",
  appId: "1:1035462327573:web:88ccd397de815627dd7d1c",
  measurementId: "G-KJ9RBHCW39"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
const analytics = getAnalytics(app);

// Initialize Firestore
const db = getFirestore(app);

// Export the Firebase app and services
export { app, analytics, logEvent, db }; 